var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.componentView)?_c('div',[_vm._v("Loading permits...")]):_c(_vm.componentView,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }